module.exports = __webpack_public_path__ + "static/img/Screenshot_2.3a78436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Screenshot_2.png
// module id = oEbZ
// module chunks = 1